module.exports = "/packs/banner_sp_writer-6bd233cd9ef52ad81c5dc740cb1c07cc.png";